import { memo, useMemo } from "react";
import { Box } from "@mui/material";
import { oids } from "@/configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { useFormatter } from "@/utils/useFormatter";
import { TeleconsultoriaAgendasSection } from "../../schedule-manager/components/TeleconsultoriaAgendasSection";
import { AvailabilityInvitesCard } from "./AvailabilityInvitesCard";
import { UpcomingTeleconsultoriasSection } from "./UpcomingTeleconsultoriasSection";

/**
 * Visão PROFISSIONAL da prestadora, numa tela só:
 * - Disponibilidade e convites (cartão único, só Tasks);
 * - Próximas teleconsultorias (filtro de data, Iniciar/Aceitar na própria linha);
 * - Minha agenda de teleconsultoria (horários, consultas, editar, desativar).
 * Desktop: 2 colunas (principal = próximas). Mobile: disponibilidade → próximas → agenda.
 */
export const ProviderProfessionalView = memo(function ProviderProfessionalView() {
  const { user } = useSessionContext();
  const myPractitionerReference = `Practitioner/${oids.cpf}-${user?.username}`;
  // Criar agenda aqui é sempre para si: o gestor-profissional não precisa escolher.
  const myProfessionalOption = useMemo(
    () => ({
      label: useFormatter.formatNameDisplay(user?.name || ""),
      value: myPractitionerReference,
    }),
    [user?.name, myPractitionerReference],
  );

  return (
    <Box
      sx={{
        display: "grid",
        gap: 3,
        alignItems: "start",
        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 2fr) minmax(280px, 1fr)" },
        gridTemplateAreas: {
          xs: `"availability" "upcoming" "agendas"`,
          md: `"upcoming availability" "upcoming agendas"`,
        },
      }}
    >
      <Box sx={{ gridArea: "availability", minWidth: 0 }}>
        <AvailabilityInvitesCard />
      </Box>
      <Box sx={{ gridArea: "upcoming", minWidth: 0 }}>
        <UpcomingTeleconsultoriasSection />
      </Box>
      <Box sx={{ gridArea: "agendas", minWidth: 0 }}>
        <TeleconsultoriaAgendasSection
          title="Minha agenda de teleconsultoria"
          practitionerReference={myPractitionerReference}
          createPresetProfessional={myProfessionalOption}
        />
      </Box>
    </Box>
  );
});
